export default __webpack_public_path__ + "static/media/gambar-24.2b0e56b9.png";